import dynamic from "next/dynamic";

export const DynamicHero030 = dynamic(() => import("./Hero030"), {
  suspense: true,
});
